// /src/utils/orgMembershipMessages.js

const DISCORD_URL = 'https://discord.gg/dXhWQpkM24';

/**
 * Corporate copy for org membership gate (identity check hub).
 * @param {{ status?: string, rsiOrgUrl?: string, organizationName?: string }} orgMembership
 */
export function getOrgMembershipNotice(orgMembership) {
  const status = orgMembership?.status;
  const orgName = orgMembership?.organizationName || 'Pallas Invictus';
  const rsiOrgUrl = orgMembership?.rsiOrgUrl || 'https://robertsspaceindustries.com/orgs/PISC';

  switch (status) {
    case 'not_applicant':
      return {
        tone: 'info',
        title: 'Organization membership required',
        body: `Your RSI handle has been verified, but you are not currently listed as a member of ${orgName}. You may submit a membership application on Roberts Space Industries, or request temporary Guest access to join public calendar events.`,
        ctaLabel: 'Apply on RSI',
        ctaUrl: rsiOrgUrl,
        external: true,
        guestHint:
          'Not an applicant yet? You can request Guest access below to attend public events while you decide whether to apply.',
      };
    case 'application_declined':
      return {
        tone: 'blocked',
        title: 'Access cannot be granted',
        body: `Your membership application to ${orgName} was not approved at this time. For confidentiality and security reasons, we are unable to provide further details through this portal. If you believe this is an error, please contact an officer through our official Discord server. You may still request Guest access for public events.`,
        ctaLabel: 'Contact us on Discord',
        ctaUrl: DISCORD_URL,
        external: true,
        guestHint:
          'You can request Guest access below to attend public calendar events while this is resolved.',
      };
    case 'application_pending':
      return {
        tone: 'pending',
        title: 'Application under review',
        body: `Thank you for applying to ${orgName}. Your membership application is currently under review by our recruitment team. While you wait for an officer's decision, you may request Guest access to join public calendar events.`,
        guestHint:
          'Waiting on recruitment? Request Guest access below so you can still join public events in the meantime.',
      };
    default:
      return null;
  }
}

export function isOrgMembershipEligible(orgMembership, isSuperAdmin) {
  if (orgMembership?.eligible === true) return true;
  if (orgMembership?.status === 'member') return true;
  return false;
}
